import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function VendorBilledCtrl ($state, $scope, $translate, tableApi, workshopAPI) {

  $scope.showBillerVendors = !!$scope.vendors.length;
  $scope.tableCacheKey     = 'vendorBilled';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        classes: 'all-caps',
        field  : 'company_name',
        header : {
          text: $translate.instant('COMPANY_SPACE.COMPANY')
        },
      },
      {
        field : 'phone',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.PHONE')
        }
      },
      {
        field : 'email',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.EMAIL')
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewVendor(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_SUPPLIERS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/vendors/biller_child_count', $scope.vendor.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewVendor(event.row);
  };

  $scope.viewVendor = function (vendor) {
    $state.go('app.vendor', {
      id: vendor.id
    });
  };

  $scope.getVendors = ( params ) => {
    return workshopAPI.get('/vendors/biller_child_list', [
      $scope.vendor.id,
      params.offset,
      params.pageSize,
    ]).then(vendors => {
      $scope.vendors = vendors;

      return vendors;
    });
  };
}